
import { defineComponent, PropType } from 'vue'
import HospitalCassette from '@/components/block/HospitalCassette.vue'
import LatterBlockCassette from '@/components/block/LatterBlockCassette.vue'
import EventBanner from '@/components/block/EventBanner.vue'
import Alert from '@/components/elements/Alert.vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  components: {
    HospitalCassette,
    LatterBlockCassette,
    EventBanner,
    Alert,
    Button
  },

  props: {
    list: {
      type: Array,
      default: () => []
    },
    type: {
      type: String as PropType<'hospital' | 'latter'>,
      default: 'hospital'
    }
  }
})
